import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Skeleton } from "@/components/ui/skeleton";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ClosuresPanel } from "@/components/admin/ClosuresPanel";
import { ClassBookingForm } from "@/components/admin/ClassBookingForm";
import { StatCards } from "@/components/admin/StatCards";
import { AdminFilters } from "@/components/admin/AdminFilters";
import { BookingsTable } from "@/components/admin/BookingsTable";
import { api, apiError } from "@/lib/api";

export default function Admin() {
  const [filters, setFilters] = useState({ status: "all", date: "", q: "" });
  const [data, setData] = useState(null);

  const load = useCallback(() => {
    const params = {};
    if (filters.status !== "all") params.status = filters.status;
    if (filters.date) params.date = filters.date;
    if (filters.q.trim()) params.q = filters.q.trim();
    return api.get("/admin/bookings", { params }).then((r) => setData(r.data)).catch((e) => toast.error(apiError(e)));
  }, [filters]);

  useEffect(() => {
    const t = setTimeout(load, 250);
    return () => clearTimeout(t);
  }, [load]);

  const cancel = async (id) => {
    try {
      await api.post(`/bookings/${id}/cancel`);
      toast.success("Booking cancelled");
      load();
    } catch (e) {
      toast.error(apiError(e));
    }
  };

  return (
    <main className="mx-auto max-w-7xl px-6 py-16 md:px-12" data-testid="admin-page">
      <p className="eyebrow rise">Control room</p>
      <h1 className="rise d1 mt-4 font-display text-4xl font-bold uppercase tracking-tight text-white sm:text-5xl">Admin dashboard</h1>
      <div className="mt-12 space-y-8">
        <StatCards stats={data?.stats} />
        <Tabs defaultValue="bookings">
          <TabsList className="mb-8 bg-[#121216]">
            <TabsTrigger value="bookings" data-testid="admin-tab-bookings">Bookings</TabsTrigger>
            <TabsTrigger value="classes" data-testid="admin-tab-classes">Class booking</TabsTrigger>
            <TabsTrigger value="closures" data-testid="admin-tab-closures">Closure days</TabsTrigger>
          </TabsList>
          <TabsContent value="bookings" className="space-y-8">
            <AdminFilters filters={filters} setFilters={setFilters} />
            {data === null ? <Skeleton className="h-64 w-full" /> : <BookingsTable bookings={data.bookings} onCancel={cancel} />}
          </TabsContent>
          <TabsContent value="classes"><ClassBookingForm onDone={load} /></TabsContent>
          <TabsContent value="closures"><ClosuresPanel onChange={load} /></TabsContent>
        </Tabs>
      </div>
    </main>
  );
}
